import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

const ReactModalAdapter = ({ className, ...props }) => {
  const contentClassName = `${className}__content`;
  const overlayClassName = `${className}__overlay`;

  Modal.setAppElement('#root');

  return (
    <Modal
      portalClassName={className}
      className={contentClassName}
      overlayClassName={overlayClassName}
      {...props}
    />
  );
};

ReactModalAdapter.propTypes = {
  className: PropTypes.string,
};

export default ReactModalAdapter;
